import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { fadeIn } from '../../../../animations/form-error';
import { BasePageComponent } from '../../../base-page';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { IOption } from '../../../../ui/interfaces/option';
import { Subject } from 'rxjs';
import { CashKey } from '../../cash/cash-key';
import { AccountService } from '../../../../services/ServiceEntity/account.service';
import { FormService } from '../../../../shared/services/form.service';
import { TransactionsService } from '../../../../services/ServiceEntity/transactions.service';
import { CodeService } from '../../../../services/ServiceEntity/code.service';
import { CUserService } from '../../../../services/ServiceEntity/c-user.service';
import { AccountUserService } from '../../../../services/ServiceEntity/account-user.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CountryColumnName } from '../../countries/country-column-name';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { TCModalService } from '../../../../ui/services/modal/modal.service';
import { CostsRuleService } from '../../fees/costs-rule.service';
import { CountryService } from '../../countries/countries.service';
import { Store } from '@ngrx/store';
import { IAppState } from '../../../../interfaces/app-state';
import { HttpService } from '../../../../services/http/http.service';
import { filter, map, takeUntil } from 'rxjs/operators';
import { BASE_URL } from '../../../../../environments/environment';
import { BTN_POPUP_CLASS, CONTAINER_DIALOG_POPUP } from '../../../../shared/constant/css-style/css-class.constant';
import { IMobileAccount } from '../../../../model/mobile-account.model';
import { STATUS } from '../../../../model/account.model';
import { TIME_LONG_REQUEST, TIME_MIN_X_REQUEST } from '../../../../shared/constant/request.contant';
import { Content } from '../../../../ui/interfaces/modal';
import { IBuildingFormByStep, INextForm } from '../dynamic-form.init';
import { DynamicFormModel } from '../../../../model/champs_formulaire/dynamic-form.model';
import { ChampsFormulaireService } from '../../champs_formulaires/champs_formulaires/champs-formulaire.service';
import { BaseDynamicComponent } from '../../../../shared/layouts/base-dynamic.component';
import { DynamicService } from '../../../../services/dynamic.service';
import { SIZE_MEDIUM_POPUP, SIZE_MIN_POPUP } from '../../../../shared/constant/css-style/css-size.constant';
import { RetraitCodePartielComponent } from '../retrait-code-partiel/retrait-code-partiel.component';
import {
  ID_SERVICE_ITEM_INFORMATION_CODE_PARTIEL,
  SERVICE_ITEM_ID_INFORMATION_CODE_PARTIEL
} from '../../../../shared/constant/service-item.constant';
import { ICashModel } from '../../cash/cash-data-model';

@Component({
  selector: 'app-retrait-code-valid-dynamic',
  templateUrl: './retrait-code-valid-dynamic.component.html',
  animations: [fadeIn]
})
export class RetraitCodeValidDynamicComponent extends BaseDynamicComponent
  implements OnInit, OnDestroy {

  transfertCode: UntypedFormGroup;
  retraitCode: UntypedFormGroup;
  allCachOutForm: UntypedFormGroup;
  PartialCachOutForm: UntypedFormGroup;

  theDialogRef: MatDialogRef<RetraitCodeValidDynamicComponent>;

  loadingMessagesForm: boolean;
  loadingCodeForm: boolean;
  loadingAllCashOut: boolean;
  loadingPartialCashOut: boolean;
  loadingTransfertCompte: boolean;

  CurentUser: any;
  CurentUserCuser: any;
  currentMobileAccount: any;
  cUserMobileAccount: any;
  accountNumber: any;
  countrylist: IOption[];
  country: any;
  countries: any;
  SelectedContry: any;
  //
  sentAmount: number;
  countryTrader: string;
  moneySource: string;
  moneyDest: string;
  error: string;
  //
  ReponseTransfert: any;
  successTransfert = false;
  errorTransfert = false;
  CountryDestID: any;
  //Tabs
  TabsEnvoiCode: boolean;
  TabsRetraitCode: boolean;
  TabsTransFert: boolean;
  retraitCodeForm: boolean;

  //transfertCompte
  transfertCompteSuccess = false;
  transfertCompteFail = false;
  transfertCompteERROR: any;

  nextFormData: INextForm;
  buildingFormData: IBuildingFormByStep;

  private subs$ = new Subject<void>();

  //Identity type
  identityType: IOption[] = [
    {
      'label': 'CNI',
      'value': 'CNI'
    },
    {
      'label': 'Passe Port',
      'value': 'Passe Port'
    },
    {
      'label': 'Permis conduire',
      'value': 'Permis conduire'
    },
    {
      'label': 'Carte Résident',
      'value': 'Carte Résident'
    }
  ];

  finalAllCashOutVal: any;


  constructor(
    private dialog: MatDialog,

    protected dynamicService: DynamicService,
    private cashKey: CashKey,
    @Inject(MAT_DIALOG_DATA) public data: ICashModel,
    private accountService: AccountService,
    private formService: FormService,
    private formulaireService: ChampsFormulaireService,
    private transactionsService: TransactionsService,
    private codeService:CodeService,
    private cUserService:CUserService,
    private mAccountService:AccountUserService,
    private dialogRef: MatDialogRef<RetraitCodeValidDynamicComponent>,
    private columnName: CountryColumnName,
    private fb: UntypedFormBuilder,
    private http: HttpClient,
    private modal: TCModalService,
    private costsRuleService: CostsRuleService,
    private countryService: CountryService,
    store: Store<IAppState>, httpSv: HttpService) {
    super(dynamicService, store, httpSv);
    console.log('## construct retrait code valid');
    this.theDialogRef = this.dialogRef;
    this.loadingMessagesForm = false;
    this.TabsRetraitCode = true;
    this.retraitCodeForm = true;
    this.countrylist = [];

    let transfertCode = this.fb.group({});

    this.buildingFormData = {
      lastIndexForm: 0,
      previousIndexForm: 0,
      dynamicFormModels: [],
      bodyModels: [],
      headerModels: []
    }

    this.nextFormData = {
      init: false,
      formulaire: transfertCode,
      formBuilder: this.fb,
      dynamicFormModelsDefault: null,
      hasBuiltList: false,
      tabOption: [],
      buildingFormByStep: this.buildingFormData
    }
  }

  ngOnInit(): void {
    console.log('## retrait code valid');
    this.accountService.identity().pipe(takeUntil(this.subs$))
      .subscribe(account => {
        console.log('## get account');
        this.CurentUser = account;
        console.log('POINT CASH', this.CurentUser);
        this.initAllCashOutForm();
        this.initPartialCashOutForm();
        this.getCurrentCuser();
        this.getData('assets/data/table.json', 'tableData',
          'setLoaded');
        this.getData(`${BASE_URL}countries`, 'countries',
          'initCountry');

        const code = this.data.cashDataModel.dataCode.code;
        console.log('## the first code: ', code);

        // récupère infos sur le code.
        const data = new FormData();
        data.set('valueCode', code);
        data.set('serviceItemId', '' + this.data.cashDataModel.dataCode.serviceItemIdInfos);
//        data.set('serviceItemId', '' + SERVICE_ITEM_ID_INFORMATION_CODE_PARTIEL);
        this.showKeys(data);

        this.codeService.verifCodeDynamic(data)
          .subscribe((result) => {
            console.log('### RETRAIT CASH RESULT', result.body);
            this.data.cashDataModel.setCode(result.body);
/*            this.retraitCode.reset();
            this.successTransfert = true;
            this.retraitCodeSuccess();
            this.errorTransfert = false;
            this.loadingMessagesForm = false;*/
            //this.openModal(modalRetaitCodeBody,"Retrait Code Result")
          }, err => {
            console.log(err);
/*            this.successTransfert = false;
            this.loadingMessagesForm = false;
            this.errorTransfert = true;*/
          });

        let params = new HttpParams();
        params = params.set('idServiceItem', String(this.data.cashDataModel.dataCode.idServiceItemInfos));
        this.formulaireService.query(this.formulaireService.dynamicFormApi, params)
          .pipe(map(res => res.body))
          .subscribe((res: DynamicFormModel[]) => {
            console.log('## success get list forms');
            console.log('## res: ', res);
            this.nextForm(res, this.nextFormData);
          }, error => {
            console.log('## error get list forms: ', error);
          });
      });
  }

  ngOnDestroy() {
    console.log('## destroy envoi code');
    this.formService.free(this.subs$);
  }

  getHeaders() {
    return this.buildingFormData.headerModels;
  }

  initTransfertCode() {
    console.log('## init transfert code form');
    this.transfertCode = this.fb.group({
      numberAccount: [''],
      senderfName: ['', [Validators.required]],
      senderlName: ['', [Validators.required]],
      senderNumTel: ['', [Validators.required]],
      password: ['', [Validators.required]],
      sentAmount: ['', [Validators.required]],
      labelCountry: ['', Validators.required],
      receiverfName: ['', Validators.required],
      receiverlName: ['', Validators.required],
      receiverNumTel: ['', [Validators.required]],
      ReceivedAmount: [],
      serviceItemId: [102],
      preferenceCurrency: ['XOF']
    });
  }

  AllcashOut() {
    /*this.cashService.setElement(this.cashKey.retraitCodeValide, false);
    this.cashService.setElement(this.cashKey.appAllCashOut, true);
    console.log('## popuptab2: ',this.cashService.popupTab);*/
    // this.AllcashOutPane = true;
    // this.PartialCashPane = false;
  }

  PartialcashOut() {
    /*this.cashService.setElement(this.cashKey.retraitCodeValide, false);
    this.cashService.setElement(this.cashKey.appPartialCashOut, true);*/

    //  this.AllcashOutPane = false;
    //  this.PartialCashPane = true;
  }

  getInit() {
    return this.nextFormData.init;
  }

  /**
   * Permet de charger les éléments du formulaire
   * de l'étape suivante.
   * @param res tous les champs du formulaire.
   */
  buildPreviousForm(res: DynamicFormModel[]) {
    this.nextFormData.init = false;
    let formList = [];
    if (res.length > 0 && this.buildingFormData.previousIndexForm >= 0) {
      let i = this.buildingFormData.previousIndexForm;
      this.buildingFormData.lastIndexForm = i+1;
      let next = res[i].formulaire.steps;
      let prev;
      for (; i >= 0; i--) {
        prev = res[i].formulaire.steps;
        if (prev != next) {
          break;
        } else {
          next = prev;
        }
        formList.push(res[i]);
      }
      if(this.buildingFormData.previousIndexForm === -1) {
        this.buildingFormData.previousIndexForm = 0;
      } else {
        this.buildingFormData.previousIndexForm = i;
      }
      this.buildingFormData.dynamicFormModels = formList;
    }
    setTimeout( r => {
      this.nextFormData.init = true;
    }, TIME_MIN_X_REQUEST)
    this.buildFromEnum(null);
  }

  anyLastIndexForm(d: DynamicFormModel[]) {
    return (this.buildingFormData.lastIndexForm < d.length);
  }

  anyPreviousIndexForm(d: DynamicFormModel[]) {
    return (this.buildingFormData.previousIndexForm > 0);
  }

  initAllCashOutForm() {
    this.allCachOutForm = this.fb.group({
      identityType: ['', [Validators.required]],
      identityNumber: ['', [Validators.required]],
      password: ['', [Validators.required]],
      valueCode: [''],
      serviceItemId: [''],
      receivedAmount: [''],
      numberAccount: [''],
      receiverNumTel: [''],
      senderId: [''],
      receiverId: ['']
    });
  }

  sendRetraitCode(valid: boolean) {
    if (valid) {
      this.loadingCodeForm = true;

      setTimeout(() => {
        this.loadingCodeForm = false;
        this.retraitCode.reset();
      }, 1000);
    }
  }

  getSingleBtnClass(): string {
    return BTN_POPUP_CLASS;
  }

  //For All cash out
  sendAllCashOut(valid: boolean) {
    if (valid) {
      this.loadingAllCashOut = true;

      setTimeout(() => {
        this.loadingAllCashOut = false;
        this.allCachOutForm.reset();
      }, 1000);
    }
  }

  //Partial Cash Out
  sendPartialCashOut(valid: boolean) {
    if (valid) {
      this.loadingPartialCashOut = true;

      setTimeout(() => {
        this.loadingPartialCashOut = false;
        this.PartialCachOutForm.reset();
      }, 1000);
    }
  }

  //Valide All Cash Out
  DoneAllCachOutForm(modalRetaitCodeBody: any) {
    //init Val
   // const code = this.cashService.getCode();
    const code = undefined;
    this.allCachOutForm.value.valueCode = code.valueCode;
    this.allCachOutForm.value.serviceItemId = 102;
    this.allCachOutForm.value.receivedAmount = code.amount;
    this.allCachOutForm.value.numberAccount = this.accountNumber;
    this.allCachOutForm.value.senderId = code.senderId;
    this.allCachOutForm.value.receiverId = code.receiverId;

    this.transactionsService.withdrawalCode(this.allCachOutForm.value).subscribe((rep) => {
      console.log('### SUCCESS Retrait ALL CASH OUT', rep);
      //setTimeout(()=>{},1000);
      this.finalAllCashOutVal = rep;
      this.openModal(modalRetaitCodeBody, 'Resultats du retrait CODE All CASH', null, { closeButton: true, overlayClose: false });
      this.allCachOutForm.reset();
    }, err => {
      console.log('### ERROR Retrait ALL CASH OUT', err);
    });
  }

  getColorbyReponse() {
    /*if (this.cashService.getCode().status === 'ACTIVED') {
      return 'black';
    } else {
      return 'red';
    }*/
    return 'red';
  }

  retraitCodeSuccess() {
    this.retraitCodeForm = false;
    // this.RetraitCodeValide = true;
  }

  DisableRetraitCodeSuccess() {
    /*this.cashService.setElement(this.cashKey.retraitCodeValide, false);
    this.cashService.setElement(this.cashKey.appTabsRetraitCode, true);*/
    this.TabsRetraitCode = true;
    /* this.AllcashOutPane = false;
     this.PartialCashPane = false;*/
  }

  retraitCash() {
    //GetMapping("api/codes/valueCode/{code}")
    console.log('### RETRAIT', this.retraitCode.value.envoiCode);
    this.codeService.findByCode(this.retraitCode.value.envoiCode).subscribe((result) => {
      console.log('### RETRAIT CASH RESULT', result);
     // this.cashService.setCode(result);
      this.retraitCode.reset();
      this.retraitCodeSuccess();
      //this.openModal(modalRetaitCodeBody,"Retrait Code Result");
    }, err => {
      console.log(err);
    });
  }

  resetRetraitCodeForm() {
    this.retraitCode.reset();
    this.loadingCodeForm = false;
  }

  //All Cash Out Reset
  ResetAllCashOut() {
    this.allCachOutForm.reset();
    this.loadingAllCashOut = false;
  }

  //partial Cash out
  ResetPartialCashOut() {
    this.PartialCachOutForm.reset();
    this.loadingPartialCashOut = false;


  }

  //for partial Cash Out
  initPartialCashOutForm() {
    this.PartialCachOutForm = this.fb.group({
      identityType: ['', [Validators.required]],
      identityNumber: ['', [Validators.required]],
      password: ['', [Validators.required]],
      valueCode: [''],
      serviceItemId: [''],
      receivedAmount: ['', [Validators.required]],
      numberAccount: [''],
      receiverNumTel: [''],
      senderId: [''],
      receiverId: ['']
    });
  }


  getCurrentCuser() {
    this.cUserService.findOneByUserLogin(this.CurentUser.login).subscribe((response) => {
      this.CurentUserCuser = response.body;
      console.log('CUSER POINT CASH', this.CurentUserCuser);
      //console.log("Current User",this.CurentUser);
      this.getCurrentMobileAccount();
    }, (err) => {
      console.log(err);
    });
  }

  getCurrentMobileAccount() {
    this.mAccountService.findAllAccountsByCUserId(this.CurentUserCuser.id)
      .pipe(
        filter((res: HttpResponse<IMobileAccount[]>) => res.ok),
        map((res: HttpResponse<IMobileAccount[]>) => res.body)
      )
      .subscribe((val: IMobileAccount[]) => {
        console.log('## mobiles accounts: ', val);
        const res = val.filter(m => (m.status === STATUS.actived));
        console.log('## res:', res);
        this.cUserMobileAccount = res['0'];
        //  this.cUserMobileAccount = val['0'];
        this.accountNumber = this.cUserMobileAccount.numberAccount;
        console.log('NUMBER Account', this.accountNumber);
      }, err => {
        console.log(err);
      });
  }

  getCountryByLabel(label) {
    this.getData(`${BASE_URL}countries/label/${label}`, 'country', 'initCountryDestID');
  }

  initCountryDestID() {
    setTimeout(() => {
      this.CountryDestID = this.country.mId;
      console.log('### DESt Country ID', this.CountryDestID);
    }, 0);
  }

  copyInputMessage(inputElement){
    console.log('## copy: ', inputElement);
    inputElement.select();
    document.execCommand('copy');
    inputElement.setSelectionRange(0, 0);
    console.log('## copy: ', inputElement.value);
  }

  confirm() {
    console.log('## confirmer');
    this.dialog.open(this.data.cashDataModel.dataCode.component, {
      minWidth: SIZE_MIN_POPUP,
      minHeight: SIZE_MEDIUM_POPUP,
      maxHeight: '500px',
      panelClass: CONTAINER_DIALOG_POPUP,
      data: this.data
    });
    this.dialogRef.close();
  }
  /**
   * Ouvre le template html {@link EnvoiCodeComponent}
   * dans un popup.
   */
  openRetraitCodeValidDynamic(dialog: MatDialog, component: any, code: string) {
    console.log('## open retrait code all cash out');
    dialog.open(component, {
      minWidth: SIZE_MIN_POPUP,
      minHeight: SIZE_MEDIUM_POPUP,
      panelClass: CONTAINER_DIALOG_POPUP,
      data: code
    });
  }

  /**
   * Permet d'effectuer un envoie code.
   * @param forModal
   * @param forfooter
   * @constructor
   */
  envoiCode(forModal: any, forfooter?: any) {
    console.log('## envoie code');
    this.loadingMessagesForm = true;
    this.successTransfert = false;
    this.errorTransfert = false;
    this.getCountryByLabel(this.transfertCode.value.labelCountry);
    this.transfertCode.value.numberAccount = this.accountNumber;
    console.log('## number account: ', this.transfertCode.value.numberAccount);
    console.log('### POST:', this.transfertCode.value);
    setTimeout(
      () => {
        if (this.CurentUserCuser.countryId === this.CountryDestID) {//transfert National
          console.log('transfert NATIONAL');
          this.transactionsService.transferCode(this.transfertCode.value)
            .subscribe((rep) => {
              console.log('### SUCCESS Transfert Code', rep);
              this.manageMessageWhenSucceed(rep);
              this.showDetailsEnvoieCode(forModal,
                'Details Transaction', null,
                {
                  closeButton: true,
                  overlayClose: false
                }); // after 700ms
            }, err => {
              console.log('ERROR While TRANS', err);
              this.manageMessageWhenError();
            });
        } else {//transfert International api/transactions/transferCodeInter
          console.log('transfert INTERNATIONAL');
          console.log('CUSER CURRENT', this.CurentUserCuser.countryId);
          this.transactionsService.transferCodeInter(this.transfertCode.value)
            .subscribe((rep) => {
              console.log('### SUCCESS Transfert Code', rep);
              this.manageMessageWhenSucceed(rep);
              this.showDetailsEnvoieCode(forModal,
                'Details Transaction', null,
                {
                  closeButton: true,
                  overlayClose: false
                }); // after 700ms
            }, err => {
              console.log('ERROR While TRANS', err);
              this.manageMessageWhenError();
            });
        }
      },
      1000
    );
  }

  /**
   * Affiche les détails de la transaction
   * lorsqu'elle a réussi.
   * @param modal
   * @param title
   * @param footer
   * @param options
   */
  showDetailsEnvoieCode(modal, title: string, footer, options) {
    console.log('## showDetailsEnvoieCode');
    console.log('## modal: ', modal);
    console.log('## title: ', title);
    setTimeout(() => {
      this.openModal(modal, title, footer, options, 'envoi-code');
    }, TIME_LONG_REQUEST);
  }

  /**
   * show or delete message infos.
   * @param response the response of the transaction.
   * @private
   */
  private manageMessageWhenError() {
    this.successTransfert = false;
    this.loadingMessagesForm = false;
    this.errorTransfert = true;
  }

  /**
   * show or delete message infos.
   * @param response the response of the transaction.
   * @private
   */
  private manageMessageWhenSucceed(response) {
    this.errorTransfert = false;
    this.loadingMessagesForm = false;
    this.successTransfert = true;
    this.ReponseTransfert = response;
    this.transfertCode.reset();
  }

  //Initialiser les Country pour le Select
  initCountry() {
    console.log('## init country');
    setTimeout(() => {
      console.log('COUNTRIES size: ', this.countries?.length);
      this.countrylist = [];
      this.countries?.forEach(element => {
        console.log('## country element: ', element);
        this.countrylist.push({ 'label': element.label, 'value': element.label });
      });
    });
  }

  resetMessagesForm() {
    this.transfertCode.reset();
    this.loadingMessagesForm = false;
  }

  openModal<T>(body: Content<T>, header: Content<T> = null,
               footer: Content<T> = null, options: any = null,
               theClass?: string) {
    this.modal.open({
      body: body,
      header: header,
      footer: footer,
      options: options,
      theClass: theClass
    });
  }

  closeModal() {
    console.log('## close envoi code');
    this.dialogRef.close();
  }

  isInvalid(): boolean {
    return this.formService.isInvalidForm(this.transfertCode);
  }

  isRequired(column: string): boolean {
    return this.formService.isRequired(this.transfertCode, column);
  }

  isInvalidDirtyOrtouched(column: string): boolean {
    return this.formService.isInvalidDirtyOrTouched(this.transfertCode,
      column);
  }

  getMinLength(column: string): number {
    return this.formService.getMinLength(this.transfertCode, column);
  }

  getMaxLength(column: string): number {
    return this.formService.getMaxLength(this.transfertCode, column);
  }

  hasErrorEmail(column: string): boolean {
    return this.formService.hasErrorEmail(this.transfertCode, column);
  }

  hasErrorPattern(column: string): boolean {
    return this.formService.hasErrorPattern(this.transfertCode, column);
  }

  hasErrorMinLength(column: string): boolean {
    return this.formService.hasErrorMinLength(this.transfertCode, column);
  }

  hasErrorMaxLength(column: string): boolean {
    return this.formService.hasErrorMaxLength(this.transfertCode, column);
  }
}
